import log from 'salvo-lite/log'

class ProductCardAtc {
    constructor (theme, elem) {
        this._elem = elem
        this._buttons = document.querySelectorAll('.btn-add-to-cart-ajax')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)

        for (let button of this._buttons) {
            button.addEventListener('click', e => {
                let gridItem = button.closest('.grid-view-item')
                if (gridItem.hasAttribute('data-product-id')) {
                    this._productsWithoutVariants(gridItem)
                } else {
                    this._productsWithVariants(gridItem)
                }
            })
        }
    }

    _productsWithoutVariants (gridItem) {
        let productId = gridItem.dataset.productId
        let productTitle = gridItem.title
        productTitle = productTitle.trim()
        window.cart.add(productId, productTitle)
    }

    _productsWithVariants (gridItem) {
        let swatch = gridItem.querySelector('.item-swatch')
        let option = swatch.querySelector('li.active')
        let variantId = option.dataset.variantId
        let productTitle = option.title
        productTitle = productTitle.trim()
        window.cart.add(variantId, productTitle)
    }
}

export default ProductCardAtc



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductCardAtc.js